import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@common/services/AuthService/AuthService';
import { ClientService } from '@common/services/ClientService/ClientService';
import { AreaService } from '@common/services/AreaService/AreaService';
import { SortableTableComponent } from '@common/components/SortableTableComponent/sortableTable.component';
import { ClientDetails } from '@common/models/clientDetails.model';
import { AreasData } from '@common/models/areasData.model';
import { QueryParameters } from '@common/models/queryParameters.model';

@Component({
  templateUrl: './clientDetailsView.component.html',
  styleUrls: ['./clientDetailsView.component.scss'],
})
export class ClientDetailsViewComponent implements OnInit {
  public clientKey: string;
  public clientDetails: ClientDetails = {
    clientKey: null,
    clientName: null,
    areaCount: null,
  };
  public bottomLevelName: string;
  public notFound = false;
  public areasNumber: number;
  public areasData: AreasData = {
    areas: [],
    areasNumber: null,
  };
  queryParameters: QueryParameters = {
    query: '',
    orderBy: '',
    sortOrder: 'ASC',
    page: 1,
  };
  dataFetchingTimeout;
  @ViewChild('areasTableComponent') areasTableComponent: SortableTableComponent;

  public fields = [
    { shortName: 'officeName', fullName: 'buildingName', type: 'string', sortable: true, width: '25%' },
    { shortName: 'levelName', fullName: 'floor', type: 'string', sortable: true, width: '25%' },
    { shortName: 'areaName', fullName: 'name', type: 'string', sortable: true, width: '26%' },
    { shortName: 'employeesNumber', fullName: 'employees', type: 'string', sortable: true, width: '13%', textAlign: 'center' },
  ];

  constructor(
    private route: ActivatedRoute,
    public authService: AuthService,
    public areaService: AreaService,
    public clientService: ClientService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.clientKey = params['clientKey'];
      this.getClientDetails();
      this.getAreas();
    });
  }

  handleNotFound(): void {
    this.bottomLevelName = '404';
    this.notFound = true;
  }

  getClientDetails() {
    this.clientService.getClientDetails(this.clientKey)
      .subscribe(
        (data: ClientDetails) => {
          if (data) {
            this.clientDetails = data;
            this.bottomLevelName = this.clientDetails.clientName;
          } else {
            this.handleNotFound();
          }
        },
        (error) => {
          if (error.status === 404) {
            this.handleNotFound();
          } else {
            this.authService.handleRequestError(error, this.getClientDetails.bind(this));
          }
        },
      );
  }

  getAreas() {
    this.areaService.getAreas(this.clientKey, this.queryParameters)
      .subscribe(
        (data: AreasData) => {
          this.areasData = data;

          if (this.areasTableComponent) {
            this.areasTableComponent.hideSpinner();
          }
        },
        error => this.authService.handleRequestError(error, this.getAreas.bind(this)),
      );
  }

  onParametersUpdated($event) {
    this.queryParameters = Object.assign(this.queryParameters, $event);
    this.getDataWithTimeout(this.getAreas.bind(this));
  }

  getDataWithTimeout(fn) {
    clearTimeout(this.dataFetchingTimeout);
    this.dataFetchingTimeout = setTimeout(fn, 500);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/clients/views/clientDetailsView/clientDetailsView.ts